// src/admin/pages/AdminPlaceholder.jsx
import React from "react";

export default function AdminPlaceholder({ title }) {
  return (
    <div>
      <h2 className="text-2xl font-extrabold tracking-tight">{title}</h2>
      <p className="mt-2 text-sm text-slate-600">We will implement this module next.</p>
      <div className="mt-4 rounded-2xl border border-slate-200 p-4 text-sm text-slate-600">
        Coming soon: {title} controls
      </div>
    </div>
  );
}
